module.exports = __webpack_public_path__ + "static/media/jason-mcgee.af0c99dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/jason-mcgee.jpg
// module id = 252
// module chunks = 0